import React from 'react';
import { Link } from 'react-router-dom';
import { PALETTES } from '../../utils/agentLook';
import { originSplit } from '../../utils/overview';

// Dónde viven los agentes. Es un reparto, no un avance: un agente externo funciona en su sistema (n8n, una página web u otro) y aquí solo se
// registra. Por eso no hay verde ni rojo, ni un «falta» ni una meta: dos colores de marca y lo que cada uno quiere decir.
export default function AgentsOrigin({ agents, projects, clients }) {
  const s = originSplit(agents);
  const responding = agents?.platform_responding || 0;
  return (
    <section aria-label="Dónde viven los agentes" className="rounded-3xl bg-panel ring-1 ring-line p-5 sm:p-6" style={{ boxShadow: 'var(--shadow)' }}>
      <div className="flex items-center justify-between gap-3 mb-4">
        <h2 className="font-display text-[18px] font-bold text-fg">Dónde viven los agentes</h2>
        <Link to="/agentes" className="whitespace-nowrap text-[13px] font-semibold text-fg-dim hover:text-fg rounded-full px-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-live/70">Ver agentes</Link>
      </div>
      {s.total === 0 ? (
        <p className="text-[13.5px] text-fg-dim">Todavía no hay agentes registrados.</p>
      ) : (
        <>
          <div role="img" aria-label={`${s.platform} de la plataforma y ${s.external} externos, de ${s.total} agentes`} className="flex h-3 w-full overflow-hidden rounded-full bg-raised">
            {s.platform > 0 && <span style={{ width: `${(s.platform / s.total) * 100}%`, background: PALETTES.aurora.a }} />}
            {s.external > 0 && <span style={{ width: `${(s.external / s.total) * 100}%`, background: PALETTES.lagoon.a }} />}
          </div>
          <dl className="mt-4 grid gap-4">
            <div>
              <dt className="flex items-center gap-2 text-[13.5px] font-semibold text-fg"><span aria-hidden className="h-2.5 w-2.5 rounded-full" style={{ background: PALETTES.aurora.a }} />De la plataforma <span className="font-display text-[20px] tabular-nums">{s.platform}</span></dt>
              <dd className="mt-1 text-[13px] text-fg-dim">Los atiende el motor propio{s.platform > 0 ? `; ${responding === 1 ? '1 está respondiendo' : `${responding} están respondiendo`} ahora` : ''}.</dd>
            </div>
            <div>
              <dt className="flex items-center gap-2 text-[13.5px] font-semibold text-fg"><span aria-hidden className="h-2.5 w-2.5 rounded-full" style={{ background: PALETTES.lagoon.a }} />Externos <span className="font-display text-[20px] tabular-nums">{s.external}</span></dt>
              <dd className="mt-1 text-[13px] text-fg-dim">Funcionan en su propio sistema{s.where.length ? ` (${s.where.map(([w, n]) => `${n} en ${w}`).join(', ')})` : ''}; aquí solo se registran para tenerlos a la vista.</dd>
            </div>
          </dl>
        </>
      )}
      {(projects != null || clients != null) && (
        <p className="mt-4 border-t border-line pt-3 text-[12.5px] text-fg-faint">
          {projects != null && <>{projects.toLocaleString('es-MX')} proyectos activos</>}{projects != null && clients != null && ' · '}{clients != null && <>{clients.toLocaleString('es-MX')} clientes registrados</>}
        </p>
      )}
    </section>
  );
}
